<template>
  <div class="home-container">
    <div
      v-for="poi in poiList"
      :key="poi.poiId"
    >
      <div
        v-if="poi.bdList && poi.bdList.length > 0"
        class="main-panel shop-panel"
      >
        <div class="shop-name">
          {{ poi.poiName }}
        </div>

        <div
          v-for="bd in poi.bdList"
          :key="bd.bdId"
          class="bd-info border1px-bottom"
        >
          <div class="bd-basic-info">
            <div class="bd-name">
              业务经理: {{ bd.bdName }}
            </div>
            <div class="bd-job">
              {{ getBdResponsibility(bd.bdType, poi.bdList.length) }}
            </div>
          </div>

          <a
            :data-bid="$BID.ASK_FOR_HELP_CONTRACT_BD"
            :data-cid="$CID.Home"
            @click="callPhone(poi.poiId, bd.bdMis)"
          >
            <img
              class="contact-icon"
              src="@/assets/img/phone-icon@2x.png"
            />
          </a>
        </div>
      </div>
    </div>

    <div class="bottom-btn-placeholder"></div>

    <div class="bottom-btns">
      <a
        class="phone-call"
        href="tel:4000005658"
        :data-bid="$BID.ASK_FOR_HELP_CONTRACT_SERVICE"
        :data-cid="$CID.Home"
      >
        <img
          class="call-icon"
          src="@/assets/img/call-icon-for-help@2x.png"
          alt=""
        />
        <span>联系客服</span>
      </a>
    </div>
  </div>
</template>

<script>
import ContactBdApi from '@/api/contactBd';
import STATUS from '@/constants/status';
import Store from '@/store/index';

export default {
  name: 'AskForHelp',
  data() {
    return {
      poiList: [],
    };
  },
  created() {
    this.getPoiBdMapList();
  },
  methods: {
    getPoiIdsFromStore() {
      const { state: { poiList = [] } = {} } = Store;
      const poiIdList = [];

      poiList.forEach((poi) => {
        if (!poi.poiId) return;

        this.poiList.push(poi);
        poiIdList.push(poi.poiId);
      });

      return poiIdList.join(',');
    },

    async getPoiBdMapList() {
      this.$store.commit('setLoading', true);
      try {
        const poiIds = this.getPoiIdsFromStore();
        const { status, data } = await ContactBdApi.getBDInfoByPoiIds(poiIds);

        if (status !== STATUS.SUCCESS || !data) return;

        this.poiList = this.poiList.map((poi) => ({
          ...poi,
          bdList: poi && poi.poiId ? data[poi.poiId] : [],
        }));
      } catch (e) {
        console.error(e);
      } finally {
        this.$store.commit('setLoading', false);
      }
    },

    //  type仅用于区分bd类型，展示不同文案，其他地方不具备参考性。 0-合作BD, 1-维护BD。
    getBdResponsibility(type, BdCount) {
      if (BdCount === 1) return '解决开店宝账户、钱包、机柜维护、补宝取货等问题';
      if (type === 0) return '解决开店宝账户、钱包收益问题';
      if (type === 1) return '解决机柜维护、取货补宝问题';
      return '';
    },

    async callPhone(poiId, misId) {
      this.$dialog.loading.show();

      try {
        const { status, data } = await ContactBdApi.getBDPhoneByPoiId(poiId, misId);

        if (status !== STATUS.SUCCESS || !data) return;

        window.location.href = `tel:${data}`;
      } catch (e) {
        console.error(e);
      } finally {
        this.$dialog.loading.hide();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/css/mixin';
@include borderCreator("border1px-bottom", "bottom", solid, rgba(0, 0, 0, 0.12));

.home-container {
  padding-top: 0.18rem;
}

.shop-panel {
  padding: 0.3rem 0.36rem 0.36rem;

  &:nth-of-type(1) {
    margin-top: 0;
  }

  .shop-name {
    margin-bottom: 0.2rem;
    font-size: 0.32rem;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.84);
  }

  .bd-info {
    padding: 0.2rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .bd-name {
      font-size: 0.26rem;
      color: rgba(0, 0, 0, 0.84);
      margin-bottom: 0.06rem;
    }

    .bd-job {
      font-size: 0.24rem;
      color: #999;
    }

    .contact-icon {
      width: 0.36rem;
      height: 0.36rem;
    }

    &:nth-last-of-type(1) {
      padding-bottom: 0;
      border-bottom: none;
    }
  }
}

.bottom-btn-placeholder {
  height: 0.9rem;
}

.bottom-btns {
  background: #fff;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  bottom: env(safe-area-inset-bottom);
  padding: 20px 36px 30px;

  .phone-call {
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(0,0,0,0.5);

    .call-icon {
      width: 0.36rem;
      height: 0.36rem;
      display: inline-block;
      margin-right: 0.14rem;
    }
  }
}
</style>
